import Vue from 'vue';
import axios from 'axios';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import messages from '@/locale';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(Antd);

const i18n = new VueI18n({
  locale: 'en', // 默认语言
  messages, // 多语言配置
});



Date.prototype.format = function (fmt) { //author: meizz 
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "H+": this.getHours(), //小时 
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}



new Vue({
    el: '#app',
    i18n,
    router,
    template: '<App/>',
    components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js